import { MonoBehavior } from 'game/core/monoBehavior';
import { Container, Sprite } from 'pixi.js';

import { Card } from './Card';
import { getCardAsset, getCardBackAsset } from 'constants/cardAssetsList';
import { Layout } from 'game/LayoutManager';
import { Store } from 'game/store/gameStore';
export class CardHintDisplay extends MonoBehavior {
    card: Card;
    reverse: Container;
    reverseSprite?: Sprite;
    averse: Container;
    averseSprite?: Sprite;
    container: Container;
    blockTween?: gsap.core.Tween;

    constructor(card: Card) {
        super();
        this.card = card;
        this.container = new Container();
        this.reverse = new Container();
        this.averse = new Container();
        this.card.container.addChild(this.container);
        if (card.visible) this.container.addChild(this.averse);
        else this.container.addChild(this.reverse);
        this.redraw();
    }

    async redraw() {
        const txt = await getCardBackAsset(Store.back);

        const reverseSprite = new Sprite(txt);
        reverseSprite.anchor.set(0.5);
        const txtColor = await getCardAsset(Store.front, this.card.code, this.card.cardColor);
        const averseSprite = Sprite.from(txtColor);

        averseSprite.anchor.set(0.5);
        const cardSize = Layout.getCardSize();

        if (this.reverseSprite && this.reverseSprite.texture && reverseSprite.texture)
            this.reverseSprite.texture = reverseSprite.texture;
        else {
            this.reverseSprite = reverseSprite;
            this.reverse.addChild(this.reverseSprite);
        }
        if (this.averseSprite && this.averseSprite.texture && averseSprite.texture)
            this.averseSprite.texture = averseSprite.texture;
        else {
            this.averseSprite = averseSprite;
            this.averse.addChild(this.averseSprite);
        }
        this.averseSprite.width = cardSize.width;
        this.reverseSprite.width = cardSize.width;
        this.averseSprite.height = cardSize.height;
        this.reverseSprite.height = cardSize.height;
    }

    destroy(): void {
        super.destroy();
        this.container.destroy({ children: true });
    }
}
